import { Controller } from "@hotwired/stimulus"

function preventEnterKey(event: KeyboardEvent) {
  if (event.key === "Enter") {
    event.preventDefault()
  }
}

function stripLineBreaks(event: Event) {
  const input = event.target as HTMLTextAreaElement
  if (/[\r\n]/.test(input.value)) {
    input.value = input.value.replace(/[\r\n]+/g, " ")
  }
}

export default class extends Controller<HTMLTextAreaElement> {
  connect() {
    if (/[\r\n]/.test(this.element.value)) {
      this.element.value = this.element.value.replace(/[\r\n]+/g, " ")
    }
    this.element.addEventListener("keydown", preventEnterKey)
    this.element.addEventListener("input", stripLineBreaks)
  }

  disconnect() {
    this.element.removeEventListener("keydown", preventEnterKey)
    this.element.removeEventListener("input", stripLineBreaks)
  }
}
